var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPopularItem = function SvgPopularItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7C144"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.241 11.956.114.241.264.04 6.593 1.004c.17.027.316.202.284.42l-.001.006a.384.384 0 0 1-.104.216l-4.771 4.87-.177.182.04.25 1.128 6.879c.037.223-.109.4-.274.43a.293.293 0 0 1-.195-.031l-.002-.002-5.899-3.247-.24-.133-.242.133-5.9 3.248a.3.3 0 0 1-.33-.026.364.364 0 0 1-.118-.159.407.407 0 0 1-.022-.213l1.128-6.88.04-.25-.177-.18-4.771-4.872a.392.392 0 0 1-.109-.27.394.394 0 0 1 .102-.271.318.318 0 0 1 .183-.1h.001l6.596-1.004.263-.04.114-.24L15.706 5.7v-.001c.09-.189.288-.24.433-.165a.347.347 0 0 1 .154.163l2.948 6.26Z",
    fill: "#FBFAFA",
    stroke: "#F7C144"
  })));
};

export default SvgPopularItem;